exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cursor[data-v-4b0b3c2e]:hover{cursor:pointer}", ""]);

// exports
